'use client';

import React from 'react';

// ─── CULTURAL CENTER / DIAWARA / ARCHIVE SECTION ───────────────────────────────
// Extracted from Behance gallery: https://www.behance.net/gallery/112291665/Monolyth-(VR)
// Sections: UPDATES → Cultural Center/Venue → Diawara → Eddies Archive

const CULTURAL_CENTER_IMAGE = 'https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/bea9e1112291665.6011beb460d87.jpg';
const DIAWARA_IMAGE = 'https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/a243cc112291665.6011beb45fd48.jpg';
const ARCHIVE_IMAGE = 'https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/16090c112291665.6011beb460696.jpg';
const ARCHIVE_TEXTURED = 'https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/e93516112291665.6011c376f28f4.jpg';
const DIA_GATE_IMAGE = 'https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/8e0a88112291665.6011c376f30c0.jpg';
const DETROIT_IMAGE_2 = 'https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/8e3bdd112291665.6011ca1b274af.jpg';

export default function CulturalCenterSection() {
  return (
    <section id="cultural-center" style={{ backgroundColor: '#fff' }}>
      {/* UPDATES heading */}
      <div style={{ padding: '0 7.1%', marginBottom: 20 }}>
        <div style={{ textAlign: 'center' }}>
          <span style={{
            color: '#696969',
            fontFamily: 'helvetica, arial, sans-serif',
            fontSize: 20,
            fontWeight: 400
          }}>UPDATES</span>
        </div>
      </div>

      {/* Chicago 360 panoramas */}
      <div style={{ marginBottom: 4 }}>
        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
          <iframe
            src="https://renderstuff.com/tools/360-panorama-web-viewer-embed/?image=https://i.imgur.com/xPu8MvS.jpeg"
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }}
            allowFullScreen
            title="Chicago 360 Panorama 3"
          />
        </div>
      </div>
      <div style={{ marginBottom: 20 }}>
        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
          <iframe
            src="https://renderstuff.com/tools/360-panorama-web-viewer-embed/?image=https://i.imgur.com/6fEGkjj.jpeg"
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }}
            allowFullScreen
            title="Chicago 360 Panorama 4"
          />
        </div>
      </div>

      {/* Cultural Center/Venue heading */}
      <div style={{ padding: '0 7.1%', marginBottom: 20 }}>
        <div style={{ textAlign: 'center' }}>
          <span style={{
            color: '#696969',
            fontFamily: 'helvetica, arial, sans-serif',
            fontSize: 20,
            fontWeight: 400
          }}>Cultural Center/Venue</span>
        </div>
      </div>

      {/* Cultural Center description */}
      <div style={{ padding: '0 7.1%', marginBottom: 20, maxWidth: 'calc(800px + 14.2%)', margin: '0 auto 20px' }}>
        <div style={{
          color: '#696969',
          fontFamily: 'helvetica, arial, sans-serif',
          fontSize: 20,
          fontWeight: 400,
          lineHeight: '1.4em'
        }}>
          I began to make 3D environments to showcase the Glyphs. These surreal environments were often made of and textured with the glyphs. While building them It felt as though I were exploring them as I would teh abandoned sites they were based on. I want to bring this exploration to others as I would often bring my friends to abandoned industrial sites, a guided tour of sorts. The first variation of this new guided exploration was a VR/360 animation flying through a glyph environment.
        </div>
      </div>

      {/* Cultural Center image */}
      <div style={{ marginBottom: 20 }}>
        <img src={CULTURAL_CENTER_IMAGE} alt="Cultural Center/Venue" style={{ width: '100%', display: 'block' }} />
      </div>

      {/* Under Construction caption */}
      <div style={{ padding: '0 7.1%', marginBottom: 20, maxWidth: 'calc(800px + 14.2%)', margin: '0 auto 20px' }}>
        <div style={{
          color: '#696969',
          fontFamily: 'helvetica, arial, sans-serif',
          fontSize: 20,
          fontWeight: 400,
          lineHeight: '1.4em',
          textAlign: 'center',
          fontStyle: 'italic'
        }}>
          <em>Under Construction</em>: Looking towards the back of the venue at the Crystal Hangar and skylights
        </div>
      </div>

      {/* Entrance caption */}
      <div style={{ padding: '0 7.1%', marginBottom: 20, maxWidth: 'calc(800px + 14.2%)', margin: '0 auto 20px' }}>
        <div style={{
          color: '#696969',
          fontFamily: 'helvetica, arial, sans-serif',
          fontSize: 20,
          fontWeight: 400,
          lineHeight: '1.4em',
          textAlign: 'center'
        }}>
          The Enterance, Crystal hangar details, View from empty first half, lightcube portal and semicompleted first half/ upper levels of the venue.
        </div>
      </div>

      {/* Cultural Center 360 panorama */}
      <div style={{ marginBottom: 20 }}>
        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
          <iframe
            src="https://renderstuff.com/tools/360-panorama-web-viewer-embed/?image=https://i.imgur.com/EUlplHK.jpeg"
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }}
            allowFullScreen
            title="Cultural Center 360 Panorama"
          />
        </div>
      </div>

      {/* ── DIAWARA ── */}
      <div style={{ padding: '0 7.1%', marginBottom: 20 }}>
        <div style={{ textAlign: 'center' }}>
          <span style={{
            color: '#696969',
            fontFamily: 'helvetica, arial, sans-serif',
            fontSize: 20,
            fontWeight: 400
          }}>Diawara</span>
        </div>
      </div>

      {/* Diawara description */}
      <div style={{ padding: '0 7.1%', marginBottom: 20, maxWidth: 'calc(800px + 14.2%)', margin: '0 auto 20px' }}>
        <div style={{
          color: '#696969',
          fontFamily: 'helvetica, arial, sans-serif',
          fontSize: 20,
          fontWeight: 400,
          lineHeight: '1.4em'
        }}>
          The first external level consisting of the reminants of &apos;Dia&apos; an earth crystal reliant culture. Their crystals power various relic technology, once that level&apos;s challange is completed the hangar can be acessed via scale shifting abilities. (level based on the beirut explosion glyphs)
        </div>
      </div>

      {/* Diawara image */}
      <div style={{ marginBottom: 20 }}>
        <img src={DIAWARA_IMAGE} alt="Diawara level" style={{ width: '100%', display: 'block' }} />
      </div>

      {/* Diawara 360 panoramas */}
      <div style={{ marginBottom: 4 }}>
        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
          <iframe
            src="https://renderstuff.com/tools/360-panorama-web-viewer-embed/?image=https://i.imgur.com/ItdISfs.jpeg"
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }}
            allowFullScreen
            title="Diawara 360 Panorama 1"
          />
        </div>
      </div>
      <div style={{ marginBottom: 4 }}>
        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
          <iframe
            src="https://renderstuff.com/tools/360-panorama-web-viewer-embed/?image=https://i.imgur.com/V5Duibc.jpeg"
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }}
            allowFullScreen
            title="Diawara 360 Panorama 2"
          />
        </div>
      </div>
      <div style={{ marginBottom: 4 }}>
        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
          <iframe
            src="https://renderstuff.com/tools/360-panorama-web-viewer-embed/?image=https://i.imgur.com/Fn3BbNJ.jpeg"
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }}
            allowFullScreen
            title="Diawara 360 Panorama 3"
          />
        </div>
      </div>
      <div style={{ marginBottom: 20 }}>
        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
          <iframe
            src="https://renderstuff.com/tools/360-panorama-web-viewer-embed/?image=https://i.imgur.com/2IfSrYa.jpeg"
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }}
            allowFullScreen
            title="Diawara 360 Panorama 4"
          />
        </div>
      </div>

      {/* ── EDDIES ARCHIVE ── */}
      <div style={{ padding: '0 7.1%', marginBottom: 20 }}>
        <div style={{ textAlign: 'center' }}>
          <span style={{
            color: '#696969',
            fontFamily: 'helvetica, arial, sans-serif',
            fontSize: 20,
            fontWeight: 400
          }}>Eddies Archive</span>
        </div>
      </div>

      {/* Archive description */}
      <div style={{ padding: '0 7.1%', marginBottom: 20, maxWidth: 'calc(800px + 14.2%)', margin: '0 auto 20px' }}>
        <div style={{
          color: '#696969',
          fontFamily: 'helvetica, arial, sans-serif',
          fontSize: 20,
          fontWeight: 400,
          lineHeight: '1.4em'
        }}>
          The second half of the Cultural Center, an archive documenting/explaining the real world locations behind the Glyphs, runes and symbols in the game via textiles and interactive galleries.
        </div>
      </div>

      {/* Archive image */}
      <div style={{ marginBottom: 20 }}>
        <img src={ARCHIVE_IMAGE} alt="Eddies Archive" style={{ width: '100%', display: 'block' }} />
      </div>

      {/* Archive Construction heading */}
      <div style={{ padding: '0 7.1%', marginBottom: 20 }}>
        <div style={{ textAlign: 'center' }}>
          <span style={{
            color: '#696969',
            fontFamily: 'helvetica, arial, sans-serif',
            fontSize: 20,
            fontWeight: 400
          }}>Archive Construction</span>
        </div>
      </div>

      {/* Archive 360 panoramas */}
      <div style={{ marginBottom: 4 }}>
        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
          <iframe
            src="https://renderstuff.com/tools/360-panorama-web-viewer-embed/?image=https://i.imgur.com/ybBfCYO.jpeg"
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }}
            allowFullScreen
            title="Archive 360 Panorama 1"
          />
        </div>
      </div>
      <div style={{ marginBottom: 4 }}>
        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
          <iframe
            src="https://renderstuff.com/tools/360-panorama-web-viewer-embed/?image=https://i.imgur.com/us7I9To.jpeg"
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }}
            allowFullScreen
            title="Archive 360 Panorama 2"
          />
        </div>
      </div>
      <div style={{ marginBottom: 20 }}>
        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
          <iframe
            src="https://renderstuff.com/tools/360-panorama-web-viewer-embed/?image=https://i.imgur.com/JkvroPw.jpeg"
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }}
            allowFullScreen
            title="Archive 360 Panorama 3"
          />
        </div>
      </div>

      {/* Archive textured image */}
      <div style={{ marginBottom: 20 }}>
        <img src={ARCHIVE_TEXTURED} alt="Archive textured with Chicago drone shot" style={{ width: '100%', display: 'block' }} />
      </div>

      {/* Archive textured caption */}
      <div style={{ padding: '0 7.1%', marginBottom: 20, maxWidth: 'calc(800px + 14.2%)', margin: '0 auto 20px' }}>
        <div style={{
          color: '#696969',
          fontFamily: 'helvetica, arial, sans-serif',
          fontSize: 20,
          fontWeight: 400,
          lineHeight: '1.4em'
        }}>
          Textured with a drone shot taken over an industrial corridor in Chicago, structure textured with street maps of River Rouge Detroit.
        </div>
      </div>

      {/* Dia Gate heading */}
      <div style={{ padding: '0 7.1%', marginBottom: 20 }}>
        <div style={{ textAlign: 'center' }}>
          <span style={{
            color: '#696969',
            fontFamily: 'helvetica, arial, sans-serif',
            fontSize: 20,
            fontWeight: 400
          }}>Dia Gate<br />Powers the archive and hangar, aquired/powered from the Diawara level. A portal to the ruins of a hybrid culture that formed as a response enviormental erosion.</span>
        </div>
      </div>

      {/* Dia Gate image */}
      <div style={{ marginBottom: 20 }}>
        <img src={DIA_GATE_IMAGE} alt="Dia Gate" style={{ width: '100%', display: 'block' }} />
      </div>

      {/* Detroit image 2 */}
      <div style={{ marginBottom: 20 }}>
        <img src={DETROIT_IMAGE_2} alt="Detroit River Rouge" style={{ width: '100%', display: 'block' }} />
      </div>
    </section>
  );
}
